export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE = 'UPLOAD_FILE_FAILURE';

export const REMOVE_FILE_REQUEST = 'REMOVE_FILE_REQUEST';
export const REMOVE_ALL_FILES_REQUEST = 'REMOVE_ALL_FILES_REQUEST';
